import clsx from 'clsx';
import { useDispatch } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';

import { useMount } from 'utils/hooks';
import { setBanners } from 'store/reducers/base';
import Time from 'components/time';
import Image from 'components/image';
import LanguageSelect from 'components/languageSelect';

import logo from 'assets/images/logo.svg';
import logoLight from 'assets/images/logo_light.svg';

import './styles.scss';

const Header = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { pathname } = useLocation();

  useMount(() => {
    dispatch(setBanners());
  });

  return (
    <header className={clsx({ isSleepMode: pathname === '/' })}>
      <Time />
      <Image
        src={pathname === '/' ? logoLight : logo}
        alt="kinopark"
        onClick={() => navigate('/home')}
      />
      <LanguageSelect />
    </header>
  );
};

export default Header;
